import apiCompetition from '@/api/competition'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getCompetitionsStart: '[competition] Get competitions start',
  getCompetitionsSuccess: '[competition] Get competitions success',
  getCompetitionsFailure: '[competition] Get competitions failure',

  getCompetitionsSchoolIdStart: '[competition] Get competitions schoolId start',
  getCompetitionsSchoolIdSuccess:
    '[competition] Get competitions schoolId success',
  getCompetitionsSchoolIdFailure:
    '[competition] Get competitions schoolId failure'
}

export const actionTypes = {
  getCompetitions: '[competition] Get competition',
  getCompetitionsSchoolId: '[competition] Get competition schoolId'
}

const mutations = {
  [mutationTypes.getCompetitionsStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getCompetitionsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },

  [mutationTypes.getCompetitionsSchoolIdStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getCompetitionsSchoolIdSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsSchoolIdFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getCompetitions](context) {
    context.commit(mutationTypes.getCompetitionsStart)
    return new Promise(resolve => {
      apiCompetition
        .getCompetitions()
        .then(response => {
          context.commit(mutationTypes.getCompetitionsSuccess, response.data)
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getCompetitionsFailure, error)
        })
    })
  },

  [actionTypes.getCompetitionsSchoolId](context, {schoolId, schoolType}) {
    context.commit(mutationTypes.getCompetitionsSchoolIdStart)
    return new Promise(resolve => {
      apiCompetition
        .getCompetitionsSchoolId(schoolId, schoolType)
        .then(response => {
          context.commit(
            mutationTypes.getCompetitionsSchoolIdSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getCompetitionsSchoolIdFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
